/** Get Oncall data */
export const GET_ONCALLS_SUCCESS = "GET_ONCALLS_SUCCESS";
export const GET_ONCALLS_FAIL = "GET_ONCALLS_FAIL";
export const GET_ONCALLS = "GET_ONCALLS";
export const POST_ONCALLS = "POST_ONCALLS";
export const POST_ONCALLS_FAIL = "POST_ONCALLS_FAIL";
